import styles from './JumbotronDescription.module.scss';

const JumbotronDescription: React.FC<Required<React.PropsWithChildren>> = ({
  children,
}) => <div className={styles.description}>{children}</div>;

export default JumbotronDescription;
